import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { MdArrowBack, MdSave, MdPerson, MdEmail, MdPhone, MdLocationOn, MdAttachMoney, MdRepeat, MdAccountCircle, MdCameraAlt } from 'react-icons/md';
import { clientesAPI, formatDateForAPI, usuariosAPI } from '../services/api';
import { useModal } from '../context/ModalContext';

const PAISES = [
  'México',
  'Afganistán', 'Albania', 'Alemania', 'Andorra', 'Angola', 'Antigua y Barbuda',
  'Arabia Saudita', 'Argelia', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaiyán', 'Bahamas', 'Bangladés', 'Barbados', 'Baréin', 'Bélgica', 'Belice',
  'Benín', 'Bielorrusia', 'Birmania (Myanmar)', 'Bolivia', 'Bosnia y Herzegovina',
  'Botsuana', 'Brasil', 'Brunéi', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Bután',
  'Cabo Verde', 'Camboya', 'Camerún', 'Canadá', 'Catar', 'Chad', 'Chile', 'China',
  'Chipre', 'Ciudad del Vaticano', 'Colombia', 'Comoras', 'Corea del Norte',
  'Corea del Sur', 'Costa de Marfil', 'Costa Rica', 'Croacia', 'Cuba', 'Dinamarca',
  'Dominica', 'Ecuador', 'Egipto', 'El Salvador', 'Emiratos Árabes Unidos',
  'Eritrea', 'Eslovaquia', 'Eslovenia', 'España', 'Estados Unidos', 'Estonia',
  'Esuatini', 'Etiopía', 'Filipinas', 'Finlandia', 'Fiyi', 'Francia', 'Gabón',
  'Gambia', 'Georgia', 'Ghana', 'Granada', 'Grecia', 'Guatemala', 'Guinea',
  'Guinea Ecuatorial', 'Guinea-Bisáu', 'Guyana', 'Haití', 'Honduras', 'Hungría',
  'India', 'Indonesia', 'Irak', 'Irán', 'Irlanda', 'Islandia', 'Islas Marshall',
  'Islas Salomón', 'Israel', 'Italia', 'Jamaica', 'Japón', 'Jordania',
  'Kazajistán', 'Kenia', 'Kirguistán', 'Kiribati', 'Kuwait', 'Laos', 'Lesoto',
  'Letonia', 'Líbano', 'Liberia', 'Libia', 'Liechtenstein', 'Lituania',
  'Luxemburgo', 'Macedonia del Norte', 'Madagascar', 'Malasia', 'Malaui',
  'Maldivas', 'Malí', 'Malta', 'Marruecos', 'Mauricio', 'Mauritania',
  'Micronesia', 'Moldavia', 'Mónaco', 'Mongolia', 'Montenegro', 'Mozambique',
  'Namibia', 'Nauru', 'Nepal', 'Nicaragua', 'Níger', 'Nigeria', 'Noruega',
  'Nueva Zelanda', 'Omán', 'Países Bajos', 'Pakistán', 'Palaos', 'Panamá',
  'Papúa Nueva Guinea', 'Paraguay', 'Perú', 'Polonia', 'Portugal', 'Reino Unido',
  'República Centroafricana', 'República Checa', 'República del Congo',
  'República Democrática del Congo', 'República Dominicana', 'Ruanda',
  'Rumanía', 'Rusia', 'Samoa', 'San Cristóbal y Nieves', 'San Marino',
  'San Vicente y las Granadinas', 'Santa Lucía', 'Santo Tomé y Príncipe',
  'Senegal', 'Serbia', 'Seychelles', 'Sierra Leona', 'Singapur', 'Siria',
  'Somalia', 'Sri Lanka', 'Sudáfrica', 'Sudán', 'Sudán del Sur', 'Suecia',
  'Suiza', 'Surinam', 'Tailandia', 'Tanzania', 'Tayikistán', 'Timor Oriental',
  'Togo', 'Tonga', 'Trinidad y Tobago', 'Túnez', 'Turkmenistán', 'Turquía',
  'Tuvalu', 'Ucrania', 'Uganda', 'Uruguay', 'Uzbekistán', 'Vanuatu',
  'Venezuela', 'Vietnam', 'Yemen', 'Yibuti', 'Zambia', 'Zimbabue',
  'Otro',
];

const NewClientContainer = styled.div`
  width: 100%;
  max-width: 100%;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};
  margin-bottom: ${props => props.theme.spacing.xl};
`;

const BackButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.backgroundLight};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  color: ${props => props.theme.colors.textPrimary};
  transition: ${props => props.theme.transitions.fast};
  cursor: pointer;

  svg {
    font-size: 1.5rem;
  }

  &:hover {
    background-color: ${props => props.theme.colors.background};
    border-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
  }
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontSizes.xxxl};
  color: ${props => props.theme.colors.textPrimary};
  margin: 0;
`;

const FormCard = styled.div`
  background: ${props => props.theme.colors.backgroundLight};
  border-radius: ${props => props.theme.borderRadius.lg};
  padding: ${props => props.theme.spacing.xl};
  box-shadow: ${props => props.theme.shadows.card};
`;

const FormSection = styled.div`
  margin-bottom: ${props => props.theme.spacing.xl};

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xl};
  color: ${props => props.theme.colors.textPrimary};
  margin: 0 0 ${props => props.theme.spacing.sm} 0;
  font-weight: ${props => props.theme.fontWeights.semibold};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};

  svg {
    color: ${props => props.theme.colors.primary};
  }
`;

const SectionDescription = styled.p`
  font-size: ${props => props.theme.fontSizes.sm};
  color: ${props => props.theme.colors.textSecondary};
  margin: 0 0 ${props => props.theme.spacing.lg} 0;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${props => props.theme.spacing.lg};
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sm};
`;

const Label = styled.label`
  font-size: ${props => props.theme.fontSizes.sm};
  color: ${props => props.theme.colors.textPrimary};
  font-weight: ${props => props.theme.fontWeights.medium};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.xs};

  span.required {
    color: ${props => props.theme.colors.danger};
  }
`;

const Input = styled.input`
  padding: ${props => props.theme.spacing.md};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: ${props => props.theme.fontSizes.sm};
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.textPrimary};
  transition: ${props => props.theme.transitions.fast};

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.backgroundLight};
    outline: none;
  }

  &::placeholder {
    color: ${props => props.theme.colors.textLight};
  }
`;

const TextArea = styled.textarea`
  padding: ${props => props.theme.spacing.md};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: ${props => props.theme.fontSizes.sm};
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.textPrimary};
  font-family: ${props => props.theme.fonts.primary};
  min-height: 100px;
  resize: vertical;
  transition: ${props => props.theme.transitions.fast};

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.backgroundLight};
    outline: none;
  }

  &::placeholder {
    color: ${props => props.theme.colors.textLight};
  }
`;

const Select = styled.select`
  padding: ${props => props.theme.spacing.md};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: ${props => props.theme.fontSizes.sm};
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.textPrimary};
  cursor: pointer;
  transition: ${props => props.theme.transitions.fast};

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.backgroundLight};
    outline: none;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.md};
  justify-content: flex-end;
  margin-top: ${props => props.theme.spacing.xl};
  padding-top: ${props => props.theme.spacing.xl};
  border-top: 1px solid ${props => props.theme.colors.border};
`;

const Button = styled.button`
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
  background-color: ${props => props.primary ? props.theme.colors.primary : props.theme.colors.backgroundLight};
  color: ${props => props.primary ? 'white' : props.theme.colors.textPrimary};
  border: 1px solid ${props => props.primary ? props.theme.colors.primary : props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: ${props => props.theme.fontSizes.sm};
  font-weight: ${props => props.theme.fontWeights.semibold};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  transition: ${props => props.theme.transitions.fast};
  cursor: pointer;

  svg {
    font-size: 1.25rem;
  }

  &:hover {
    background-color: ${props => props.primary ? props.theme.colors.primaryDark : props.theme.colors.background};
    transform: translateY(-1px);
    box-shadow: ${props => props.theme.shadows.sm};
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
  padding: ${props => props.theme.spacing.md};
  background-color: ${props => props.theme.colors.background};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  transition: ${props => props.theme.transitions.fast};
  cursor: pointer;

  &:hover {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.backgroundLight};
  }
`;

const Checkbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: ${props => props.theme.colors.primary};
  flex-shrink: 0;
`;

const CheckboxLabel = styled.label`
  font-size: ${props => props.theme.fontSizes.sm};
  color: ${props => props.theme.colors.textPrimary};
  font-weight: ${props => props.theme.fontWeights.medium};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  flex: 1;

  svg {
    color: ${props => props.theme.colors.primary};
    font-size: 1.25rem;
  }
`;

const RecurringSection = styled.div`
  margin-top: ${props => props.theme.spacing.lg};
  padding: ${props => props.theme.spacing.lg};
  background-color: ${props => props.theme.colors.background};
  border: 2px dashed ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  animation: fadeIn 0.3s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const PhotoUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
`;

const PhotoPreview = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid ${props => props.theme.colors.border};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.background};
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    font-size: 4rem;
    color: ${props => props.theme.colors.textLight};
  }
`;

const PhotoUploadButton = styled.label`
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.lg};
  background-color: ${props => props.theme.colors.primary};
  color: white;
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: ${props => props.theme.fontSizes.sm};
  font-weight: ${props => props.theme.fontWeights.medium};
  cursor: pointer;
  transition: ${props => props.theme.transitions.fast};
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};

  &:hover {
    background-color: ${props => props.theme.colors.primaryDark};
    transform: translateY(-1px);
  }

  input {
    display: none;
  }
`;

const NewClient = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const { toast } = useModal();
  const [loading, setLoading] = useState(isEditMode);
  const [submitting, setSubmitting] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    direccion: '',
    ciudad: '',
    codigoPostal: '',
    pais: 'México',
    rfc: '',
    regimenFiscal: 'Persona Física con Actividad Empresarial',
    foto: null,
    fotoPreview: null,
    montoInicial: '',
    frecuenciaPago: 'Mensual',
    metodoPago: 'Transferencia Bancaria',
    notas: '',
    // Campos de recibo recurrente
    habilitarRecurrente: false,
    frecuenciaRecurrente: 'Mensual',
    montoRecurrente: '',
    descripcionRecurrente: '',
    diaCargo: '1', // Para Diario, Mensual (día del mes)
    diaSemana: 'Lunes', // Para Semanal
    mesAnual: '1', // Para Anual (mes)
    diaAnual: '1', // Para Anual (día del mes)
    asignado_a: '',
  });

  useEffect(() => {
    usuariosAPI.getAll().then(r => setUsuarios(r.data.data || [])).catch(() => {});
  }, []);

  // Cargar datos del cliente si estamos en modo edición
  useEffect(() => {
    if (isEditMode) {
      loadClientData();
    }
  }, [id]);

  const loadClientData = async () => {
    try {
      setLoading(true);
      const response = await clientesAPI.getById(id);
      const cliente = response.data.data;

      setFormData({
        nombre: cliente.nombre || '',
        email: cliente.email || '',
        telefono: cliente.telefono || '',
        empresa: cliente.empresa || '',
        direccion: cliente.direccion || '',
        ciudad: cliente.ciudad || '',
        codigoPostal: cliente.codigo_postal || '',
        pais: cliente.pais || 'México',
        rfc: cliente.rfc || '',
        regimenFiscal: cliente.regimen_fiscal || 'Persona Física con Actividad Empresarial',
        foto: null,
        fotoPreview: cliente.foto_url || null,
        montoInicial: '',
        frecuenciaPago: 'Mensual',
        metodoPago: 'Transferencia Bancaria',
        notas: cliente.notas || '',
      });
    } catch (error) {
      console.error('Error al cargar cliente:', error);
      toast('Error al cargar datos del cliente', 'error');
      navigate('/clientes');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          foto: file,
          fotoPreview: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    try {
      // Preparar datos del cliente (solo campos que existen en la BD)
      const clienteData = {
        nombre: formData.nombre,
        email: formData.email,
        telefono: formData.telefono,
        empresa: formData.empresa || null,
        direccion: formData.direccion || null,
        ciudad: formData.ciudad || null,
        codigo_postal: formData.codigoPostal || null,
        pais: formData.pais || 'México',
        rfc: formData.rfc,
        regimen_fiscal: formData.regimenFiscal,
        foto_url: formData.fotoPreview || null,
        notas: formData.notas || null,
        asignado_a: formData.asignado_a || null,
      };

      // Solo agregar campos financieros si NO estamos en modo edición
      // (estos campos solo se usan al crear para generar recibo inicial)
      if (!isEditMode) {
        clienteData.monto_inicial = formData.montoInicial ? parseFloat(formData.montoInicial) : 0;
        clienteData.frecuencia_pago = formData.frecuenciaPago || 'Mensual';
        clienteData.metodo_pago = formData.metodoPago || 'Transferencia Bancaria';
        
        // Si hay recibo recurrente, agregarlo (solo en creación)
        if (formData.habilitarRecurrente) {
          clienteData.habilitarRecurrente = true;
          clienteData.frecuenciaRecurrente = formData.frecuenciaRecurrente;
          clienteData.montoRecurrente = parseFloat(formData.montoRecurrente);
          clienteData.descripcionRecurrente = formData.descripcionRecurrente || 'Recibo recurrente';
          
          // Agregar información del día según frecuencia
          if (formData.frecuenciaRecurrente === 'Semanal') {
            clienteData.diaSemana = formData.diaSemana;
          } else if (formData.frecuenciaRecurrente === 'Mensual') {
            clienteData.diaCargo = parseInt(formData.diaCargo);
          } else if (formData.frecuenciaRecurrente === 'Anual') {
            clienteData.mesAnual = parseInt(formData.mesAnual);
            clienteData.diaAnual = parseInt(formData.diaAnual);
          }
        }
      }

      // Crear o actualizar cliente
      let response;
      if (isEditMode) {
        // Actualizar cliente
        response = await clientesAPI.update(id, clienteData);

        if (response.data.success) {
          toast('Cliente actualizado exitosamente', 'success');
          navigate(`/clientes/${id}`);
        }
      } else {
        response = await clientesAPI.create(clienteData);
        if (response.data.success) {
          toast('Cliente creado exitosamente', 'success');
          navigate('/clientes');
        }
      }
    } catch (error) {
      console.error('Error al crear/actualizar cliente:', error);
      toast('Error al crear/actualizar cliente: ' + (error.message || 'Error desconocido'), 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <NewClientContainer>
        <div style={{ textAlign: 'center', padding: '60px' }}>
          <p>Cargando datos del cliente...</p>
        </div>
      </NewClientContainer>
    );
  }

  return (
    <NewClientContainer>
      <PageHeader>
        <BackButton onClick={handleCancel}>
          <MdArrowBack />
        </BackButton>
        <Title>{isEditMode ? 'Editar Cliente' : 'Nuevo Cliente'}</Title>
      </PageHeader>

      <FormCard>
        <form onSubmit={handleSubmit}>
          <FormSection>
            <SectionTitle>
              <MdPerson />
              Información Personal
            </SectionTitle>
            <SectionDescription>
              Datos básicos del cliente
            </SectionDescription>
            
            <PhotoUploadContainer style={{ marginBottom: '2rem' }}>
              <PhotoPreview>
                {formData.fotoPreview ? (
                  <img src={formData.fotoPreview} alt="Preview" />
                ) : (
                  <MdAccountCircle />
                )}
              </PhotoPreview>
              <PhotoUploadButton>
                <MdCameraAlt />
                Subir Foto
                <input
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoChange}
                />
              </PhotoUploadButton>
            </PhotoUploadContainer>

            <FormGrid>
              <FormGroup>
                <Label>
                  Nombre Completo <span className="required">*</span>
                </Label>
                <Input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Ej: Juan Pérez García"
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  <MdEmail style={{ fontSize: '1rem' }} />
                  Correo Electrónico
                </Label>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ejemplo@correo.com"
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  <MdPhone style={{ fontSize: '1rem' }} />
                  Teléfono
                </Label>
                <Input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder="+52 000 000 000"
                />
              </FormGroup>

              <FormGroup>
                <Label>Empresa</Label>
                <Input
                  type="text"
                  name="empresa"
                  value={formData.empresa}
                  onChange={handleChange}
                  placeholder="Nombre de la empresa (opcional)"
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  RFC
                </Label>
                <Input
                  type="text"
                  name="rfc"
                  value={formData.rfc}
                  onChange={handleChange}
                  placeholder="XAXX010101000"
                  maxLength="13"
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Régimen Fiscal
                </Label>
                <Input
                  type="text"
                  name="regimenFiscal"
                  value={formData.regimenFiscal}
                  onChange={handleChange}
                  placeholder="Ej: Persona Física con Actividad Empresarial"
                />
              </FormGroup>
            </FormGrid>
          </FormSection>

          <FormSection>
            <SectionTitle>
              <MdLocationOn />
              Dirección
            </SectionTitle>
            <SectionDescription>
              Información de ubicación del cliente
            </SectionDescription>
            
            <FormGrid>
              <FormGroup style={{ gridColumn: '1 / -1' }}>
                <Label>Dirección Completa</Label>
                <Input
                  type="text"
                  name="direccion"
                  value={formData.direccion}
                  onChange={handleChange}
                  placeholder="Calle, número, piso, puerta"
                />
              </FormGroup>

              <FormGroup>
                <Label>Ciudad</Label>
                <Input
                  type="text"
                  name="ciudad"
                  value={formData.ciudad}
                  onChange={handleChange}
                  placeholder="Guadalajara"
                />
              </FormGroup>

              <FormGroup>
                <Label>Código Postal</Label>
                <Input
                  type="text"
                  name="codigoPostal"
                  value={formData.codigoPostal}
                  onChange={handleChange}
                  placeholder="12345"
                />
              </FormGroup>

              <FormGroup>
                <Label>País</Label>
                <Select
                  name="pais"
                  value={formData.pais}
                  onChange={handleChange}
                >
                  {PAISES.map(p => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </Select>
              </FormGroup>
            </FormGrid>
          </FormSection>

          <FormSection>
            <SectionTitle>
              <MdAttachMoney />
              Información de Pago
            </SectionTitle>
            <SectionDescription>
              Configuración de pagos y facturación
            </SectionDescription>
            
            <FormGrid>
              <FormGroup>
                <Label>Monto Inicial</Label>
                <Input
                  type="number"
                  name="montoInicial"
                  value={formData.montoInicial}
                  onChange={handleChange}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                />
              </FormGroup>

              <FormGroup>
                <Label>Frecuencia de Pago</Label>
                <Select
                  name="frecuenciaPago"
                  value={formData.frecuenciaPago}
                  onChange={handleChange}
                >
                  <option value="Diario">Diario</option>
                  <option value="Semanal">Semanal</option>
                  <option value="Quincenal">Quincenal</option>
                  <option value="Mensual">Mensual</option>
                  <option value="Trimestral">Trimestral</option>
                  <option value="Anual">Anual</option>
                </Select>
              </FormGroup>

              <FormGroup>
                <Label>Método de Pago Preferido</Label>
                <Select
                  name="metodoPago"
                  value={formData.metodoPago}
                  onChange={handleChange}
                >
                  <option value="Transferencia Bancaria">Transferencia Bancaria</option>
                  <option value="Tarjeta de Crédito">Tarjeta de Crédito</option>
                  <option value="PayPal">PayPal</option>
                  <option value="Efectivo">Efectivo</option>
                  <option value="Cheque">Cheque</option>
                </Select>
              </FormGroup>
            </FormGrid>
          </FormSection>

          {!isEditMode && (
          <FormSection>
            <SectionTitle>
              <MdRepeat />
              Recibo Recurrente Automático
            </SectionTitle>
            <SectionDescription>
              Configura un recibo que se generará automáticamente con la frecuencia seleccionada.
              Para agregar más cobros recurrentes después, hazlo desde la ficha del cliente.
            </SectionDescription>

            <CheckboxContainer onClick={(e) => {
              // Solo toggle si no se clickeó directamente el checkbox
              if (e.target.type !== 'checkbox') {
                setFormData(prev => ({ ...prev, habilitarRecurrente: !prev.habilitarRecurrente }));
              }
            }}>
              <Checkbox
                type="checkbox"
                id="habilitarRecurrente"
                name="habilitarRecurrente"
                checked={formData.habilitarRecurrente}
                onChange={(e) => {
                  setFormData(prev => ({ ...prev, habilitarRecurrente: e.target.checked }));
                }}
              />
              <CheckboxLabel htmlFor="habilitarRecurrente">
                <MdRepeat />
                Habilitar recibos recurrentes para este cliente
              </CheckboxLabel>
            </CheckboxContainer>

            {formData.habilitarRecurrente && (
              <RecurringSection>
                <FormGrid>
                  <FormGroup>
                    <Label>Frecuencia de Recibo</Label>
                    <Select
                      name="frecuenciaRecurrente"
                      value={formData.frecuenciaRecurrente}
                      onChange={handleChange}
                    >
                      <option value="Diario">Diario</option>
                      <option value="Semanal">Semanal</option>
                      <option value="Mensual">Mensual</option>
                      <option value="Anual">Anual</option>
                    </Select>
                  </FormGroup>

                  {/* Campo dinámico según frecuencia */}
                  {formData.frecuenciaRecurrente === 'Semanal' && (
                    <FormGroup>
                      <Label>Día de la Semana</Label>
                      <Select
                        name="diaSemana"
                        value={formData.diaSemana}
                        onChange={handleChange}
                      >
                        <option value="Lunes">Lunes</option>
                        <option value="Martes">Martes</option>
                        <option value="Miércoles">Miércoles</option>
                        <option value="Jueves">Jueves</option>
                        <option value="Viernes">Viernes</option>
                        <option value="Sábado">Sábado</option>
                        <option value="Domingo">Domingo</option>
                      </Select>
                    </FormGroup>
                  )}

                  {formData.frecuenciaRecurrente === 'Mensual' && (
                    <FormGroup>
                      <Label>Día del Mes</Label>
                      <Select
                        name="diaCargo"
                        value={formData.diaCargo}
                        onChange={handleChange}
                      >
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                          <option key={day} value={day}>{day}</option>
                        ))}
                      </Select>
                    </FormGroup>
                  )}

                  {formData.frecuenciaRecurrente === 'Anual' && (
                    <>
                      <FormGroup>
                        <Label>Mes del Año</Label>
                        <Select
                          name="mesAnual"
                          value={formData.mesAnual}
                          onChange={handleChange}
                        >
                          <option value="1">Enero</option>
                          <option value="2">Febrero</option>
                          <option value="3">Marzo</option>
                          <option value="4">Abril</option>
                          <option value="5">Mayo</option>
                          <option value="6">Junio</option>
                          <option value="7">Julio</option>
                          <option value="8">Agosto</option>
                          <option value="9">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Select>
                      </FormGroup>
                      <FormGroup>
                        <Label>Día del Mes</Label>
                        <Select
                          name="diaAnual"
                          value={formData.diaAnual}
                          onChange={handleChange}
                        >
                          {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>{day}</option>
                          ))}
                        </Select>
                      </FormGroup>
                    </>
                  )}

                  <FormGroup>
                    <Label>Monto del Recibo ($)</Label>
                    <Input
                      type="number"
                      name="montoRecurrente"
                      value={formData.montoRecurrente}
                      onChange={handleChange}
                      placeholder="0.00"
                      step="0.01"
                      min="0"
                    />
                  </FormGroup>

                  <FormGroup style={{ gridColumn: '1 / -1' }}>
                    <Label>Descripción del Recibo</Label>
                    <Input
                      type="text"
                      name="descripcionRecurrente"
                      value={formData.descripcionRecurrente}
                      onChange={handleChange}
                      placeholder="Ej: Servicio mensual, Renta, Suscripción..."
                    />
                  </FormGroup>
                </FormGrid>
              </RecurringSection>
            )}
          </FormSection>
          )}

          <FormSection>
            <FormGroup style={{ marginBottom: '1.5rem' }}>
              <Label>Asignar a</Label>
              <Select name="asignado_a" value={formData.asignado_a} onChange={handleChange}>
                <option value="">Sin asignar (se asignará a ti automáticamente)</option>
                {usuarios.map(u => (
                  <option key={u.id} value={u.id}>{u.nombre}</option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label>Notas Adicionales</Label>
              <TextArea
                name="notas"
                value={formData.notas}
                onChange={handleChange}
                placeholder="Información adicional sobre el cliente, acuerdos especiales, etc."
              />
            </FormGroup>
          </FormSection>

          <ButtonGroup>
            <Button type="button" onClick={handleCancel} disabled={submitting}>
              Cancelar
            </Button>
            <Button type="submit" primary disabled={submitting}>
              <MdSave />
              {submitting ? 'Guardando...' : isEditMode ? 'Actualizar Cliente' : 'Guardar Cliente'}
            </Button>
          </ButtonGroup>
        </form>
      </FormCard>
    </NewClientContainer>
  );
};

export default NewClient;
